import { Component, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CookieConsentService } from '../cookie-consent/cookie-consent.service';
import { APP_VERSION } from '../../../version';

@Component({
	standalone: false,
	selector: 'app-footer',
	templateUrl: './app-footer.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./app-footer.component.css'],
})
export class AppFooterComponent {
	/** Mostra banner loghi UE + dicitura finanziamento (false nelle build white-label cliente). */
	showFundingBranding = environment.showFundingBranding;

	/** Versione del portale da package.json. */
	appVersion = APP_VERSION;

	constructor(private readonly cookieConsent: CookieConsentService) {}

	/** Riapre il modal delle preferenze cookie. */
	openCookieSettings(): void {
		this.cookieConsent.openPreferences();
	}
}
